<div class="logout-page">
  <div class="logout-panel">
    <div class="logout-panel-content">
      <strong role="status">Logging out...</strong>
      <div class="spinner-border" aria-hidden="true"></div>
    </div>
  </div>
</div>
